import React from "react";
import PropTypes from "prop-types";

import { Header, Icon } from "semantic-ui-react";

import CommentFilter, {
  ClearFilters,
  useCommentFilterContext,
} from "./CommentFilter";
import NewComment from "./NewComment";

export default function CommentListHeader({
  activeFilters,
  client,
  hub,
  disabled,
  refetchComments,
}) {
  const filterContext = useCommentFilterContext();
  return (
    <React.Fragment>
      <Header style={{ display: "inline" }}>
        <Icon name="comment outline" />
        Comments
      </Header>
      <CommentFilter filters={activeFilters}>
        <ClearFilters onClick={filterContext.clearAllFilters} />
      </CommentFilter>
      <NewComment
        clientId={client.id}
        hub={hub}
        refetchComments={refetchComments}
        disabled={disabled}
        filterContext={filterContext}
      />
    </React.Fragment>
  );
}

CommentListHeader.propTypes = {
  activeFilters: PropTypes.array.isRequired,
  client: PropTypes.object.isRequired,
  hub: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  refetchComments: PropTypes.func.isRequired,
};
